<capra-icon-button
  class="chart-menu-icon"
  icon="icon-gear"
  size="medium"
  aria-label="Chart options menu"
  data-test="chart-options-menu-button"
  [matMenuTriggerFor]="menu"
>
</capra-icon-button>
<mat-menu #menu="matMenu" class="chart-menu">
  <button mat-menu-item (click)="toggleShowTitle()" data-test="chart-options-show-title">
    <capra-icon [style.visibility]="isShowTitle ? 'visible' : 'hidden'" icon="icon-check"> </capra-icon>
    Show title
  </button>

  <button mat-menu-item (click)="toggleShowCaption()" data-test="chart-options-show-caption">
    <capra-icon [style.visibility]="isShowCaption ? 'visible' : 'hidden'" icon="icon-check"> </capra-icon>
    Show description
  </button>

  <mat-divider></mat-divider>

  <ng-container *ngFor="let position of positions; trackBy: trackByType">
    <button
      mat-menu-item
      (click)="setPosition(position.type)"
      [class.selected]="position.type === captionPosition"
      [disabled]="!isShowCaption"
      [attr.data-test]="'chart-options-set-position-' + position.type"
    >
      <capra-icon
        [style.visibility]="isShowCaption && position.type === captionPosition ? 'visible' : 'hidden'"
        icon="icon-dot-indicator"
      >
      </capra-icon>
      {{ position.label }}
    </button>
  </ng-container>

  <ng-container *ngIf="!granularityInfo.isHidden">
    <mat-divider></mat-divider>

    <ng-container
      *ngTemplateOutlet="
        multistate;
        context: {
          state: granularityInfo,
          label: 'Show granularity controls',
          onSelect: toggleShowGranularity.bind(this),
          datatest: 'show-granularity'
        }
      "
    >
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!dataProfileInfo.isHidden">
    <mat-divider></mat-divider>
    <button mat-menu-item data-test="chart-options-show-data-profiling" (click)="toggleShowDataProfile()">
      <capra-icon [style.visibility]="dataProfileInfo.isEnabled ? 'visible' : 'hidden'" icon="icon-check"> </capra-icon>
      Show data profile
    </button>
  </ng-container>
</mat-menu>
<ng-template #multistate let-state="state" let-label="label" let-onSelect="onSelect" let-datatest="datatest">
  <ng-container *ngIf="!state.isHidden">
    <button
      mat-menu-item
      attr.data-test="chart-options-{{ datatest }}"
      [disabled]="!state.isAllowed"
      (click)="onSelect()"
    >
      <capra-icon [style.visibility]="state.isAllowed && state.isEnabled ? 'visible' : 'hidden'" icon="icon-check">
      </capra-icon>
      {{ label }}
    </button>
  </ng-container>
</ng-template>
